import React, { useState, useEffect } from 'react'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { doneLoading, startLoading } from '../../utils/loading'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import ManageProposalFormWidget from '../../widgets/projectProposal/ManageProposalFormWidget'
import { getManageProposalForm } from '../../redux/actions/subProjectFormSetting'
import ContentHeaderWidget from '../../components/ContentHeader/ContentHeaderWidget'

export default function ManageProposalForm() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getManageProposalForm()
      // const _schema = mockSchema //await getProjectTemplate()
      setSchema(_schema)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProjectReport>
          <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

          {schema?.projectTemplete && <ManageProposalFormWidget schema={schema.projectTemplete} />}
        </SidebarProposal>
      )}
    </>
  )
}
